/* eslint-disable no-console */
// Single sanctioned console.* boundary. Everywhere else in the app should
// call `logger.*` instead so log level is enforced consistently.

const LEVELS = { error: 0, warn: 1, info: 2, debug: 3 }

// Safe-by-default until configureLogger() runs (e.g. a log call that fires
// before plugins/env.js resolves the current environment).
let threshold = LEVELS.warn

// env: the { isProd, isStaging, isDev, isLocal } shape produced by
// plugins/env.js from publicRuntimeConfig.appEnv.
export function configureLogger(env) {
  if (env.isProd) {
    threshold = LEVELS.warn
  } else if (env.isStaging) {
    threshold = LEVELS.info
  } else {
    // local and development (and any unrecognized non-prod/staging env)
    threshold = LEVELS.debug
  }
}

function log(level, ...args) {
  if (LEVELS[level] <= threshold) {
    console[level](...args)
  }
}

export const logger = {
  error: (...args) => log('error', ...args),
  warn: (...args) => log('warn', ...args),
  info: (...args) => log('info', ...args),
  debug: (...args) => log('debug', ...args)
}
